import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import Box from '@mui/joy/Box';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

// Components
// import { IdentitySelectorForm } from './IdentitySelector';
import VisibilitySelectorForm from './VisibilitySelectorForm';
// import CadenceForm from './CadenceForm';
import ProjectAssets from './ProjectAssets';
import ProjectCopy from './ProjectCopy';

// Stoers
// import { Identity } from '../stores/identity_store';
import { Project } from '../stores/project_store';
import { RootStoreContext } from '../stores/root_store';


import { UserIdentityContext } from '../contexts/user_identity_context';
import { Error, Success } from './FancyToast';

const ProjectSettings = observer(({simple=false}:{simple?:boolean}) => {
    const { projectKey = "new" } = useParams<{ projectKey: string }>();
    if(projectKey === "") {
        return <pre>select a project</pre>;
    }

    const { currentIdentity }  = useContext(UserIdentityContext);

    const rootStore = useContext(RootStoreContext);
    const projectStore = useContext(RootStoreContext).projectStore;
    const project = (projectKey !== 'new' ?
        projectStore.getProject(projectKey) :
        {} as Project);

    const savedIdentity = currentIdentity;
        // project.identity ?
        // rootStore.identityStore.getIdentity(project.identity) :
        // currentIdentity;
    const [identity, setIdentity] = React.useState(savedIdentity);

    const [title, setTitle] = React.useState(project?.title || '');

    const [selectedCadence, _] = React.useState(project?.cadence || 'chat');
    const [selectedVisibility, setSelectedVisibility] = React.useState(project?.visibility ?
        project?.visibility + '' :
        '0');

    const [showExtras, setShowExtras] = React.useState(false);
    const textAreaRef = React.useRef(null);
    const navigate = useNavigate();

    console.log("selectedVisibility: %o", selectedVisibility);

    useEffect(() =>{
        if(!identity.key) {
            setIdentity(currentIdentity);
        }
    }, [currentIdentity, identity.key]);



    const handleClick = () => {
        if (title.trim() !== '') {
            const ps = rootStore.projectStore;
            if(project && project.key) {
                project.title = title;
                project.cadence = selectedCadence;
                project.visibility = parseInt(selectedVisibility);
                ps.updateProject(project)
                    .then((data) => {
                        Success('Saved Project');
                        navigate(`/project/${data.key}`);
                    });
            }
            else {
                const newProject = new Project({
                    uuid: "",
                    key: "",
                    title: title,
                    cadence: selectedCadence,
                    identity: identity.uuid,
                    visibility: parseInt(selectedVisibility),
            });
                ps.createProject(newProject)
                    .then((data) => {
                        Success('Created Project');
                        navigate(`/project/${data.key}`);
                    })
                    .catch((err) => {
                        console.log(err.message);
                        Error(err.message);
                    });
            }

            console.log("handleClick: %o", identity.key);
        }
    };

    function visibilityOnChange(e: string) {
        console.log("visibilityOnChange: %o", e);
        setSelectedVisibility(e);
    }


    // function identityKeyOnChange(e: string) {
    //     console.log("identityOnChange: %o", e);
    //     setIdentityKey(e);
    // }

    // function onCadenceUpdated(selectedCadence: string) {
    //     console.log("Setting expanded and candec to: ", selectedCadence);
    //     setSelectedCadence(selectedCadence);
    // }



    return (
        <Stack

            sx={{
                mr: "auto",
                padding: 2,

                display: 'flex',
                width: "100%"
            }}
            spacing={3}
        >

            { !simple &&
            <Typography
                level="h3">Project Details</Typography> }

                    <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Input
                            // html input attribute
                            ref={textAreaRef}
                            onChange={(e) => { setTitle(e.target.value); }}
                            value={title}
                            name="title"
                            type="title"
                            placeholder="&quot;Default Project&quot; or &quot;Q4 Marketing&quot; or &quot;🪣 Misc&quot;"
                        />

                        <FormHelperText>We'll keep our Collabs organized in Projects. (Requests are now called "Collabs")</FormHelperText>

                    </FormControl>





            { showExtras &&

            <Grid container spacing={1} >
                {/*
                <Grid md={12} lg={5} >
                    <CadenceForm
                        selectedCadence={selectedCadence}
                        setSelectedCadence={onCadenceUpdated} />

                </Grid>

                <Grid md={12} lg={7} >
                    <IdentitySelectorForm
                        identities={identities}
                        selectedIdentityKey={identityKey}
                        onChange={identityKeyOnChange} />
                </Grid>
                */}
                <Grid md={12}  >
                    <VisibilitySelectorForm
                        selectedVisibility={selectedVisibility}
                        onChange={visibilityOnChange} />
                </Grid>
            </Grid>
            }

            <Divider />
            <FormControl>
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="flex-end">

                    { !simple &&
                        <>
                    <Button
                        size="sm"
                        variant="plain"
                        onClick={() => { window.history.back(); }}>Cancel</Button>

                    <Box sx={{ flexGrow: 1 }} />


                    <Button
                        size="sm"
                        variant="plain"
                        onClick={() => { setShowExtras(!showExtras); }}>{ showExtras ? 'Hide' : 'Show' } Extras
                    </Button>
                        </>
                    }

                    <Button onClick={handleClick}>
                        {project?.key ? "Update Project" : "Create Project"}
                    </Button>

                </Stack>
            </FormControl>

        </Stack>
    );
});

export const ProjectAssetsAndSettings = observer(() => {
	return (
			<Grid container
				sx={{ flexGrow: 1, width: "100%" }} >
				<Grid sm={4}>
					<ProjectAssets  />
				</Grid>
				<Grid sm={8}>

                    <ProjectCopy />
					<ProjectSettings/>
				</Grid>
			</Grid>
	);

});


export default ProjectSettings;
